<template>
  <div class="row">
    <div v-if="showNewButton" class="col-md-12 text-right">
      <p>
        <router-link :to="{name: 'customers.create'}"><button class="btn btn-wd btn-icon btn-info"><i class="ti-plus"></i> Novo</button></router-link>
      </p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    showNewButton () {
      return this.$route.name === 'customers.index' && this.$can('customers.create')
    }
  },
  created () {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Customers/Customers.vue